import { toFormData } from '../lib/utils/forms';
import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';
import {
    ApiParticipantsListRequest,
    AppParticipantsListResponse,
    ParticipantsListResponseData,
} from './post-participants-list';

export type ApiVisitorsMaterialsRequest = ApiParticipantsListRequest;

type ApiVisitorsMaterialsResponseData = {
    title: string;
    message: string;
};

export type ApiVisitorsMaterialsResponse = ApiResponse<ApiVisitorsMaterialsResponseData>;

export type AppVisitorsMaterialsResponse = ApiResponse<ParticipantsListResponseData>;

const transformApiResponse = (response: ApiVisitorsMaterialsResponse): AppVisitorsMaterialsResponse => {
    return {
        ...response,
        data: response.data
            ? {
                  title: response.data.title,
                  description: response.data.message,
              }
            : undefined,
    };
};

export const postVisitorsMaterials = (body: ApiVisitorsMaterialsRequest): Promise<AppParticipantsListResponse> =>
    axiosAPI
        .post<ApiVisitorsMaterialsResponse>('/v1/feedback/visitors-materials', toFormData(body))
        .then((res) => transformApiResponse(res.data));
